export function ProfileSummaryCard({ u }) {
  return (
    <div className="kpi-card">
      <div className="text-[11px] uppercase text-slate-500 tracking-wider">Account</div>
      <div className="font-display text-xl font-bold text-slate-900 mt-1">{u.name}</div>
      <div className="text-sm text-slate-600">{u.email}</div>
      <div className="mt-3 flex items-center gap-2">
        <span className="pill bg-slate-100 text-slate-700 border-slate-200">{u.role}</span>
        <span className={`pill ${u.status === "approved" ? "bg-emerald-50 text-emerald-700 border-emerald-200" : "bg-amber-50 text-amber-700 border-amber-200"}`}>{u.status}</span>
      </div>
      <div className="mt-3 text-xs text-slate-500">Joined {u.created_at ? new Date(u.created_at).toLocaleDateString() : "—"}</div>
    </div>
  );
}

export function ProfileCompletionCard({ u }) {
  const checks = [
    ["Profile photo", !!u.avatar_file_id],
    ["Phone", !!u.phone],
    ["Country & city", !!(u.country && u.city)],
    ["Languages", (u.languages || []).length > 0],
    ["Skills", (u.testing_skills || []).length > 0],
    ["Devices", (u.device_inventory || []).length > 0 || (u.device_types || []).length > 0 || (u.devices || []).length > 0],
    ["Tools", (u.tools || []).length > 0],
    ["Domains", (u.domains || []).length > 0],
    ["Resume", !!u.resume_file_id],
    ["National ID", !!u.national_id_file_id],
  ];
  const done = checks.filter(x => x[1]).length;
  const pct = Math.round((done / checks.length) * 100);
  return (
    <div className="kpi-card" data-testid="profile-completion">
      <div className="flex items-center justify-between mb-2">
        <h3 className="font-display font-bold text-slate-900">Profile completion</h3>
        <span className="font-display font-bold text-cyan-700">{pct}%</span>
      </div>
      <div className="h-2 bg-slate-100 rounded-full overflow-hidden">
        <div className="h-full bg-cyan-600 transition-all" style={{ width: `${pct}%` }}/>
      </div>
      <ul className="mt-4 space-y-1.5 text-sm">
        {checks.map(([label, ok]) => (
          <li key={label} className="flex items-center gap-2">
            <span className={`w-1.5 h-1.5 rounded-full ${ok ? "bg-emerald-500" : "bg-slate-300"}`}/>
            <span className={ok ? "text-slate-700" : "text-slate-500"}>{label}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
